var EcomStep;
(function (EcomStep) {
    EcomStep[EcomStep["DEALER_CHOOSER"] = 0] = "DEALER_CHOOSER";
    EcomStep[EcomStep["TRADE_IN_EXISTS_CHOOSER"] = 1] = "TRADE_IN_EXISTS_CHOOSER";
    EcomStep[EcomStep["TRADE_IN_CAR_DEFINITION"] = 2] = "TRADE_IN_CAR_DEFINITION";
    EcomStep[EcomStep["TRADE_IN_CAR_CONDITION"] = 3] = "TRADE_IN_CAR_CONDITION";
    EcomStep[EcomStep["TRADE_IN_CONFIRM_CAR"] = 4] = "TRADE_IN_CONFIRM_CAR";
    EcomStep[EcomStep["PAYMENT_METHOD_CHOOSER"] = 5] = "PAYMENT_METHOD_CHOOSER";
    EcomStep[EcomStep["PAYMENT_FINANCING_DETAILS"] = 6] = "PAYMENT_FINANCING_DETAILS";
    EcomStep[EcomStep["BANKID_AUTHENTICATION"] = 7] = "BANKID_AUTHENTICATION";
    EcomStep[EcomStep["CUSTOMER_INFORMATION_INITIAL"] = 8] = "CUSTOMER_INFORMATION_INITIAL";
    EcomStep[EcomStep["CUSTOMER_INFORMATION_DETAILS"] = 9] = "CUSTOMER_INFORMATION_DETAILS";
    EcomStep[EcomStep["CREDIT_ASSESSMENT_INFORMATION"] = 10] = "CREDIT_ASSESSMENT_INFORMATION";
    EcomStep[EcomStep["CREDIT_ASSESSMENT_SIGNING"] = 11] = "CREDIT_ASSESSMENT_SIGNING";
    EcomStep[EcomStep["CREDIT_ASSESSED"] = 12] = "CREDIT_ASSESSED";
    EcomStep[EcomStep["INSURANCE_INFORMATION_DEFINITION"] = 13] = "INSURANCE_INFORMATION_DEFINITION";
    EcomStep[EcomStep["INSURANCE_ALTERNATIVE_CHOOSER"] = 14] = "INSURANCE_ALTERNATIVE_CHOOSER";
    EcomStep[EcomStep["ACCESSORIES_CHOOSER"] = 15] = "ACCESSORIES_CHOOSER";
    EcomStep[EcomStep["DELIVERY_METHOD"] = 16] = "DELIVERY_METHOD";
    EcomStep[EcomStep["FINAL_SUMMARY"] = 17] = "FINAL_SUMMARY";
    EcomStep[EcomStep["FINAL_CONFIRMATION"] = 18] = "FINAL_CONFIRMATION";
})(EcomStep || (EcomStep = {}));
export default EcomStep;
